export default "__VITE_ASSET__8f8ff401__"